export const FIND_REPORT_REQUEST = 'FIND_REPORT_REQUEST';

export const findReportRequest = ( id ) => ({
    type: FIND_REPORT_REQUEST,
    payload: { id }
});
